module.exports = __webpack_public_path__ + "static/dog-l-found-fbb1ab43e244fb797cd24e76faad57bf.jpg";